<template>
  <div class="mx-3">
    <div class="alert alert-success text-center" role="alert">
      <h2>Отчет по оптовику</h2>
    </div>
    <div class="container">
      <div class="mb-1 mt-1 row">
        <div class="col-sm-5 label-class">
          <Multiselect
            v-model="currentReceiver"
            :options="usersWholesaler"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="fullname"
            label="fullname"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class="deliverer"
            style="min-height: 3rem"
            noOptionsText="Не найден"
            placeholder="Оптовик"
            required
          >
          </Multiselect>
        </div>
      </div>

      <div v-if="isAdmin || isManagerFB" class="mb-1 mt-1 row">
        <div class="col-sm-5 label-class">
          <Multiselect
            v-model="selectedBerry"
            :options="berries"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="label"
            label="label"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class="deliverer"
            style="min-height: 3rem"
            noOptionsText="Не найден"
            placeholder="Ягода"
            required
          >
          </Multiselect>
        </div>
      </div>

      <div class="mt-1 row">
        <label class="col-sm-2 col-form-label">Начало</label>
        <div class="col-sm-3 label-class">
          <v-date-picker
            v-model="dateFrom"
            mode="dateTime"
            :popover="{ visibility: 'focus' }"
            is24hr
            utc
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="
                  px-2
                  border
                  rounded
                  focus:outline-none focus:border-blue-300
                "
                :value="inputValue"
                v-on="inputEvents"
                style="
                  width: 100%;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  line-height: 2;
                "
              />
            </template>
          </v-date-picker>
        </div>
      </div>

      <div class="mt-1 row">
        <label class="col-sm-2 col-form-label">Конец</label>
        <div class="col-sm-3 label-class">
          <v-date-picker
            v-model="dateTo"
            mode="dateTime"
            :popover="{ visibility: 'focus' }"
            is24hr
            utc
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="
                  px-2
                  border
                  rounded
                  focus:outline-none focus:border-blue-300
                "
                :value="inputValue"
                v-on="inputEvents"
                style="
                  width: 100%;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  line-height: 2;
                "
              />
            </template>
          </v-date-picker>
        </div>
      </div>

      <div class="mt-1 row">
        <div class="col-sm-5 label-class">
          <button type="button" class="btn btn-primary btn-lg w-100 berry" @click="getReport()">
            СФОРМИРОВАТЬ
          </button>
        </div>
      </div>
      <div class="mt-1 row">
        <div class="col-sm-5 label-class">
          <button type="button" class="btn btn-warning btn-lg w-100 berry" @click="printReport()">
            ПЕЧАТЬ
          </button>
        </div>
      </div>

      <div v-if="isAdmin" class="mt-1 row" >
        <div class="col-sm-5 label-class">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="flexCheckDefault" v-model="showWriteoffBtn"/>
            <label class="form-check-label" for="flexCheckDefault">
              Включить списание остатков
            </label>
          </div>
        </div>
      </div>
    </div>

    <ReportMasterTable
      v-if="!isMobile"
      :selected-berry="selectedBerry"
      :report="report"
      :report-sum="reportSum"
      :show-writeoff-btn="showWriteoffBtn"
      :date-to="dateTo"
      v-model:current-berry="currentBerry"
      v-model:reload-report="reloadReport"
    />

    <ReportMasterCard
      v-if="isMobile"
      :selected-berry="selectedBerry"
      :report="report"
      :report-sum="reportSum"
      v-model:current-berry="currentBerry"
    />

    <br />
    <div class="d-flex justify-content-center">
      <img class="img img-fluid" width="150" src="moroshka.png" alt="" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import { onMounted, ref, computed, watch } from "vue";
import useCommonMixin from "@/components/commonMixin.js";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";
import ReportMasterTable from "@/components/ReportMasterTable.vue";
import ReportMasterCard from "@/components/ReportMasterCard.vue";

export default {
  name: "ReportMaster",

  components: { Multiselect, ReportMasterTable, ReportMasterCard },

  setup(props) {
    useCommonMixin();
    const store = useStore();
    const { asyncForEach, userProfile, isAdmin, isManagerFB } = useCommonMixin();
    const currentReceiver = ref();
    const users = ref([]);
    const roles = ref([]);
    const dateFrom = ref("");
    const dateTo = ref("");
    const report = ref([]);
    const currentBerry = ref("");
    const selectedBerry = ref(null);
    const showWriteoffBtn = ref(false)
    const reloadReport  = ref(false)

    const { isMobile } = useCommonMixin();

    const init = async () => {
      Date.prototype.addHours = function(h) {
        this.setTime(this.getTime() + h * 60 * 60 * 1000);
        return this;
      };

      let response = await store.dispatch("FETCHuser", "receiver");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async user => {
        user.phone = user.phone ? user.phone.slice(2, 12) : "";
        user.fullname = user.receiver.fullname;
      });

      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter(role => role.type != "deliverer")
        : [];

      await store.dispatch("FETCHberry");

      let currentUserIndex = users.value.findIndex(item => item._id == userProfile.value._id);
      currentReceiver.value = currentUserIndex >= 0 ? userProfile.value._id : null;
    };

    const usersWholesaler = computed(() => {
      let wholesalerRole = roles.value.find(item => item.name == "wholesaler");
      let receiverRole = roles.value.find(item => item.name == "receiver");

      let result = [];
      if (wholesalerRole && receiverRole) {
        result = users.value.filter(
          item => item.role == wholesalerRole._id || item.role == receiverRole._id
        );
      }
      return result;
    });

    const getReport = async () => {
      report.value = [];
      let responseReport = await store.dispatch("FETCHreportMaster", {
        dateFrom: dateFrom.value ? dateFrom.value.toISOString() : new Date(1, 1, 1).toISOString(),
        dateTo: dateTo.value ? dateTo.value.toISOString() : new Date(7777, 1, 1).toISOString(),
        receiverId: currentReceiver.value,
        berryId: selectedBerry.value
      });

      report.value = responseReport.status ? responseReport.data : [];
    };

    const reportSum = computed(() => {
      let reportSum = {
        acceptWeightSumTotal: 0,
        acceptweightShrinkTotal: 0,
        acceptWeightDryTotal: 0,
        transferWeightDryTotal: 0,
        acceptWeightDryBalance: 0,
        priceAvg: 0,
        sum: 0,
        аcceptancePriceAvg: 0,
        аcceptanceSum: 0,

        priceShrink: 0,
        priceCompanyBonus: 0,
        priceReceiverBonus: 0,
        priceLogist: 0,
        priceCost: 0,
        revenueAvg: 0,
        revenueSumTotal: 0,
        bonusReceiverSumTotal: 0,
        bonusMasterSumTotal: 0
      };

      let аcceptancePriceCount = 0;
      let аcceptancePriceAvgTotal = 0;

      let priceShrink = 0;
      let priceShrinkCount = 0;
      let priceCompanyBonus = 0;
      let priceCompanyBonusCount = 0;
      let priceLogist = 0;
      let priceLogistCount = 0;
      let priceCost = 0;
      let priceCostCount = 0;
      let revenueAvg = 0;
      let revenueAvgCount = 0;

      report.value.forEach(berry => {
        reportSum.acceptWeightSumTotal =
          reportSum.acceptWeightSumTotal + berry.resultAcceptance.weightSum.total;
        reportSum.acceptweightShrinkTotal =
          reportSum.acceptweightShrinkTotal + berry.resultAcceptance.weightShrink.total;
        reportSum.acceptWeightDryTotal =
          reportSum.acceptWeightDryTotal + berry.resultAcceptance.weightDry.total;
        reportSum.transferWeightDryTotal =
          reportSum.transferWeightDryTotal + berry.resultTransfer.weightDry;
        reportSum.acceptWeightDryBalance =
          reportSum.acceptWeightDryBalance + berry.resultAcceptance.weightDry.balance;

        reportSum.аcceptanceSum += berry.resultAcceptance.sum;

        reportSum.sum = reportSum.sum + berry.resultTransfer.sum;

        reportSum.revenueSumTotal += berry.resultTransfer.revenueSumTotal;
        reportSum.bonusReceiverSumTotal += berry.resultTransfer.bonusReceiverSumTotal;
        reportSum.bonusMasterSumTotal += berry.resultTransfer.bonusMasterSumTotal;

        if (berry.resultAcceptance.priceAvg > 0) {
          аcceptancePriceAvgTotal += berry.resultAcceptance.priceAvg;
          аcceptancePriceCount += 1;
        }

        if (berry.resultTransfer.priceShrink > 0) {
          priceShrink += berry.resultTransfer.priceShrink;
          priceShrinkCount += 1;
        }

        if (berry.resultTransfer.priceCompanyBonus > 0) {
          priceCompanyBonus += berry.resultTransfer.priceCompanyBonus;
          priceCompanyBonusCount += 1;
        }

        if (berry.resultTransfer.priceLogist > 0) {
          priceLogist += berry.resultTransfer.priceLogist;
          priceLogistCount += 1;
        }

        if (berry.resultTransfer.priceCost > 0) {
          priceCost += berry.resultTransfer.priceCost;
          priceCostCount += 1;
        }

        if (berry.resultTransfer.revenueAvg > 0) {
          revenueAvg += berry.resultTransfer.revenueAvg;
          revenueAvgCount += 1;
        }
      });

      reportSum.priceShrink = priceShrink / priceShrinkCount;
      reportSum.priceCompanyBonus = priceCompanyBonus / priceCompanyBonusCount;
      reportSum.priceLogist = priceLogist / priceLogistCount;
      reportSum.priceCost = priceCost / priceCostCount;
      reportSum.revenueAvg = revenueAvg / revenueAvgCount;
      reportSum.аcceptancePriceAvg = аcceptancePriceAvgTotal / аcceptancePriceCount;
      
      if (reportSum.transferWeightDryTotal > 0) {
        reportSum.priceAvg = reportSum.sum / reportSum.transferWeightDryTotal;
      }

      return reportSum;
    });

    const printReport = () => {
      var divToPrint = document.getElementById("report-print");
      divToPrint.setAttribute("border", "1");

      let newWin = window.open("");
      newWin.document.write(divToPrint.outerHTML);
      newWin.print();
      newWin.close();
      divToPrint.setAttribute("border", "0");
    };

    const berries = computed(() => {
      let berry;
      berry = store.getters.berry;
      return berry;
    });

    watch(reloadReport, () => {
      if (reloadReport.value) {
        reloadReport.value = false
        getReport()
      }
    });

    onMounted(init);

    return {
      currentReceiver,
      usersWholesaler,
      getReport,
      dateFrom,
      dateTo,
      report,
      reportSum,
      currentBerry,
      users,
      printReport,
      berries,
      selectedBerry,
      isAdmin,
      isMobile,
      showWriteoffBtn,
      reloadReport,
      isManagerFB,
    };
  }
};
</script>

<style>
.fs-8 {
  font-size: 0.8rem !important;
}

.fs-10 {
  font-size: 1rem !important;
}
</style>
